<script setup lang="ts">
import { NDrawer } from 'naive-ui'
import { useAttrs } from 'vue'

withDefaults(defineProps<{
  show?: boolean
  placement?: 'top' | 'right' | 'bottom' | 'left'
  width?: number | string
  height?: number | string
  maskClosable?: boolean
  resizable?: boolean
  defaultWidth?: number | string
  defaultHeight?: number | string
  to?: string | HTMLElement
  displayDirective?: 'if' | 'show'
  onUpdateShow?: (show: boolean) => void
  onShow?: () => void
  onHide?: () => void
  onAfterEnter?: () => void
  onAfterLeave?: () => void
}>(), {
  show: false,
  placement: 'right',
  width: 251,
  height: 251,
  maskClosable: true,
  resizable: false,
  defaultWidth: 251,
  defaultHeight: 251,
  to: 'body',
  displayDirective: 'if',
})

const emit = defineEmits<{
  'update:show': [show: boolean]
  'show': []
  'hide': []
  'after-enter': []
  'after-leave': []
}>()

const attrs = useAttrs()

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
  if (show)
    emit('show')
  else
    emit('hide')
}

const onAfterEnter = () => {
  emit('after-enter')
}

const onAfterLeave = () => {
  emit('after-leave')
}
</script>

<template>
  <NDrawer
    :show="show"
    :placement="placement"
    :width="width"
    :height="height"
    :mask-closable="maskClosable"
    :resizable="resizable"
    :default-width="defaultWidth"
    :default-height="defaultHeight"
    :to="to"
    :display-directive="displayDirective"
    v-bind="attrs"
    @update:show="onUpdateShow"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <slot />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </NDrawer>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
